import { render } from "./ClientLine.vue?vue&type=template&id=70481418&scoped=true"
import script from "./ClientLine.vue?vue&type=script&lang=js"
export * from "./ClientLine.vue?vue&type=script&lang=js"

import "./ClientLine.vue?vue&type=style&index=0&id=70481418&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70481418"]])

export default __exports__